import React, { useEffect, useState } from "react";
import { Typography, Box, Button } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { constants, environmentVariables } from "../../../../Shared/Url/Constants";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import { IsTokenValid } from "../../../../Shared/Utill/AuthUtil";

const DuplicateEventDialog = (props) => {
    const dialog = useToggle();
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookie.get('X_TKN');
    alert(props.message)
    console.log("these are props from search page "+JSON.stringify(props.data))
    useEffect(() => {
        dialog.show();
    }, []);

    const duplicateEventAction = () => {
        // call duplicate event  api
        
        if(props.flag === "S") {
            console.log("request payload",props.data.divNbr);
            alert("we are from search")
            callDuplicateService(
                props.data.divnbr,
                props.data.prefLocation,
                props.data.store_status,
                null,
                null,
                props.data.newhire_status,
                null,
                props.data.workschedule_status,
                null)
        } else {
            alert("we are from edit" + props.divNbr)
            callDuplicateService(props.divNbr,props.locNbr,props.storeActive,props.dropDownIncrement,
                props.weeksOut,props.newHireActive,props.newHire,props.workActive,props.workSchedule); 
        }
       
    }

    const callDuplicateService = (divNbr = null, locNbr = null, storeActive = null, xMinsApart = null,
        weeksOut = null, newHireActive = null, newHire = null, workActive = null, workSchedule = null) =>{
       let data = {
            action:"D",
            divNbr: divNbr,
            locNbr: locNbr,
            duplicateFromLocNbr:locNbr,
            active:storeActive ? "y":"n",
            avlShiftSelectXminsApart: xMinsApart,
            wksout:weeksOut,
            newHireActive:newHireActive ? "y":"n",
            newHireForXdays:newHire,
            workScheduleActive:workActive ? "y":"n",
            workScheduleUnlocked:workSchedule,
            lastUpdatedBy: personDetails.emplID,
        };

       axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_APP_CONTROL_ADD_EDIT_ADMIN_APP_LOCATION_CONTROLS}`,
       data, {
        headers: {
          'content-type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
        .then((response) => {
         console.log("response is",response.data);
         if(response.status === 200){
          // success close popup
             props.onDuplicateCallback("success","Event duplicated successfully.",response.data );   
         }else{
            props.onDuplicateCallback("error","Something went wrong", response.data); 
         }
        })
        .catch((error) => {
           //catch
         props.onDuplicateCallback("error",error.response.data.message, "Error"); 
        })
    }
  
    
    const closeDialog = () => {
        dialog.hide();
        props.onCloseDialog(); 
    }
    return (
        <Box>
            <Dialog
                open={dialog.open}
                title={"Confirm Duplicate Event"}
                onClose={closeDialog}
                actions={
                    <>
                        <Button color="secondary" onClick={() => closeDialog()}>No</Button>
                        <Button onClick={() => duplicateEventAction()}>Yes</Button>
                    </>
                }
            >
                <Typography>{"Are you sure you want to duplicate this event along with all the included locations."}</Typography>
            </Dialog>
        </Box>
    );
}

export default DuplicateEventDialog;

